require('./style.less');


var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;

    },

    serializeData: function() {

        var searches = this.channel.request('state').get( 'searches' );

        return {
            searches: searches.pluck('searchTerm')
        };


    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/loadingPredefinedSearches/view.js
 ** module id = 653
 ** module chunks = 0
 **/